import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const GYMNASTICS_CONTENT_PATH = 'licenses.steps.businessInformation.forms.gymnastics';

export const gymnasticsSchema = BasicBusinessInformationSchema.extend({
  eventDate: z
    .string()
    .min(1, { message: `${GYMNASTICS_CONTENT_PATH}.eventDate.validation.required` })
    .regex(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/, {
      message: `${GYMNASTICS_CONTENT_PATH}.eventDate.validation.validFormat`,
    }),
});

export type GymnasticsSchema = z.infer<typeof gymnasticsSchema>;

export const createGymnasticsDefaults = (): GymnasticsSchema => ({
  licenseCode: LicenseTypes.Gymnastics,
  eventDate: '',
});

export const toPayloadGymnastics = (form: GymnasticsSchema, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(form.eventDate).format('YYYY-MM-DD'),
  };
};
